<template lang="pug">
.k-browser-content
  d-loading.page.loading( v-if=`!menu`)
  transition-group.page( v-else :key='menu.name' tag='div' name='fade-fast' )
    .current( v-if='current' :key=`current.id + '-current'` ref='current' )
      .spacer( ref='currentHeader' )
      template( v-if='!isCurrentPage')
        a.header(
          v-if='current.header'
          v-html='current.header.title'
          name='current-menu-item'
        )
        .content( v-if='current.content' v-html='current.content' )
      .children( v-for='( child, index ) in current.children' )
        .title( v-if=`index > 0 || child.title !== current.header.title` v-html='child.title' )
        template( v-for='item in child.children' )
          .item.media-item.flat(
              v-if=`item.type === 'attachment'`
              :key='item.id'
              :class=`{ current: item === currentEpisode }`
              @click='setEpisode( item )'
            )
            .inner
              img.thumb( :src='item.thumbnail' )
              .body
                .title( v-html='item.title.rendered' )
                .content( v-html='item.caption.rendered' )
          .item( v-else :key='item.id' )
            .inner
              img.thumb( :src='item.thumb' )
              .body( v-html='item.title' )
          
    .title.more( v-if='current' key='more' )
      | More on the Site
    template( v-for='item in menu' )
      .item.media-item(
          v-if=`item !== current && item.type === 'media'`
          :key='item.id'
          :class=`{ flat: item.flat }`
        )
        .inner
          img.thumb( :src='item.thumb' )
          .body
            router-link.title( :to='item.url' v-html='item.title' )
            .content( v-html='item.caption' )
      .item( v-else-if='item !== current' :key='item.id' @click='setCurrent( item )' )
        .inner
          img.thumb( :src='item.thumb' )
          .body( v-html='item.title' )
</template>

<script lang="js">
import { mapActions, mapState } from 'vuex'
import DLoading from '@/displays/d-loading'

export default {
  name: 'ContentBrowserBlock',
  mixins: [],
  components: { DLoading },
  props: {},
  data() {
    return {
      // items: []
      thisCurrentPage: null
    }
  },
  created() {},
  mounted() {
  },
  methods: {
    ...mapActions([ 'pushMenu', 'popMenu' ]),
    setEpisode( item ) {
      this.$router.push( item.path )
      setTimeout(() => {
        window.scrollTo( 0, 0 )
      }, 500 )
    },
    setCurrent( item ) {
      if ( item.url === '/' ) {
        if ( this.$route.path === '/' ) {
          this.thisCurrentPage = null
        } else {
          this.$router.push( '/' )
          setTimeout(() => {
            window.scrollTo( 0, 0 )
          }, 500)
        }
        return
      }
      if ( !this.hero || this.hero.name !== 'video-full' ) {
        this.$router.push( item.url )
        setTimeout(() => {
          window.scrollTo( 0, 0 )
        }, 500 )
      }
      this.thisCurrentPage = item
      setTimeout(() => {
        const current = this.$refs.currentHeader || this.$refs.current
        if ( current ) {
          current.scrollIntoView({ behavior: 'smooth' })
        }
      }, 500 )
    }
  },
  computed: {
    ...mapState([ 'hero', 'menu', 'currentPage', 'currentEpisode' ]),
    current() {
      return this.thisCurrentPage || this.currentPage
    },
    isCurrentPage() {
      return this.current.url === this.$route.fullPath
    },
    showCurrent() {
      return this.current && !this.isCurrentPage
    },
  }
}
</script>

<style lang="scss">
.k-browser-content {
  /* border: 1px solid rgba(100, 200, 255, 0.2); */
  border-radius: 6px;
  > .page {
    > .current {
      > .header {
        font-size: var(--s-2lg);
        margin-bottom: var(--s-base);
      }
      > .spacer {
        height: var(--s-3xl);
      }
      > .content {
        padding: var(--s-sm);
        text-align: justify;
      }
      .children > .title {
        font-size: var(--s-2lg);
        margin-top: var(--s-lg);
        margin-bottom: var(--s-sm);
      }
    }
    > .title {
      font-size: var(--s-2lg);
      margin-top: var(--s-lg);
      margin-bottom: var(--s-sm);
    }
    .item {
      position: relative;
      margin: 10px;
      background: #111;
      border-radius: 8px;
      box-shadow: 0 2px 3px black;
      min-height: 6em;
      padding: var(--s-base);
      transition: 400ms background;
      cursor: pointer;
      > .inner {
        transition: 250ms opacity;
        opacity: 0.5;
        position: relative;
        display: flex;
        flex-wrap: nowrap;
        align-items: center;
        .thumb {
          border-radius: 4px;
          overflow: hidden;
        }
        .body {
          flex: 1;
          text-align: left;
          padding: var(--s-base);
        }
      }
      &.media-item {
        > .inner {
          align-items: flex-start;
          max-height: 6em;
          overflow: hidden;
          display: block;
          transition: 400ms opacity, 250ms max-height;
          .thumb {
            float: left;
            margin-right: var(--s-base);
            margin-bottom: var(--s-base);
          }
          > .body {
            padding-top: 0;
            > .content {
              color: #aaa;
            }
          }
        }
        &:hover > .inner {
          max-height: 15em;
        }
      }
      &:hover {
        background: #222;
        > .inner {
          opacity: 1;
        }
      }
      &.flat {
        background: transparent;
        border: 0 none;
        box-shadow: none;
        &:hover {
          background: rgba(255,255,255,0.05);
        }
      }
      &.current {
        background: rgba(255,255,255,0.1);
      }
      &:hover {
        box-shadow: 0 2px 3px black;
      }
    }
    .title.more {
      margin-top: var(--s-xl);
    }
  }
}
</style>
